import { Tile } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/index.tsx';
import {
  DiamondBaseColor,
  DiamondBasePosition,
} from '#src/components/series/SeriesBoard/HotStreakTile/Tile/utils.ts';

export const FailedTile = () => {
  return (
    <Tile color={DiamondBaseColor.red} position={DiamondBasePosition.down} />
  );
};
